import '../../utils/index.mjs';
import Input from './src/input2.mjs';
export { inputEmits, inputProps } from './src/input.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElInput = withInstall(Input);

export { ElInput, ElInput as default };
//# sourceMappingURL=index.mjs.map
